export const FULL_TEXT_CANNOT_BE_RETRIEVED_CRITERION_TYPE =
  'Full text cannot be retrieved'
